import { Component, EventEmitter, Output } from '@angular/core';
import { IntegrationLinkedin } from '@app/models/company/settings/integrations/linkedin.model';
import { AuthService } from '@app/services';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-settings-linkedin-form',
    templateUrl: './linkedin.template.html',
})
export class LinkedinForm extends BaseForm {
    @Output() canSubmit = new EventEmitter<boolean>();

    model: IntegrationLinkedin = new IntegrationLinkedin();

    isLoading = false;

    needsConfirmation = false;
    hasConfirmed = false;

    linkedinCompanyLink = '';

    constructor(private auth: AuthService) {
        super();
    }

    findIntegrationById(id: number): void {
        this.isLoading = true;
        IntegrationLinkedin.param('company', this.auth.company.id)
            .find(id)
            .then((model) => {
                this.model = model;
                this.isLoading = false;
            });
    }

    reset(): void {
        this.model = new IntegrationLinkedin();
        this.hasConfirmed = false;
        this.needsConfirmation = false;
    }

    modelChange(): void {
        this.needsConfirmation = this.model.isFieldDirty('linkedinCompanyId') && this.model.linkedinCompanyId !== '';
        this.linkedinCompanyLink = `https://www.linkedin.com/company/${this.model.linkedinCompanyId}/`;
        this.hasConfirmed = false;
        this.canSubmit.emit(false);
    }

    confirm(): void {
        this.needsConfirmation = false;
        this.hasConfirmed = true;
        this.canSubmit.emit(true);
    }
}
